import { render, staticRenderFns } from "./PopUpVideoOne.vue?vue&type=template&id=ef0644ca&"
import script from "./PopUpVideoOne.vue?vue&type=script&lang=js&"
export * from "./PopUpVideoOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports